import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LogoFacilityComponent } from 'src/app/shared/components';
import { environment } from 'src/environments/environment';
import { RedirectionByArrivedDayComponent } from '../';
import { DHLConfigurationService } from '../../services/dhl-config.service';

@Component({
    standalone: true,
    selector: 'app-initial-modal',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    imports: [LogoFacilityComponent, MatDialogModule, MatButtonModule, MatIconModule, RedirectionByArrivedDayComponent],
})
export class MessageModalComponent {
    public urlPolar = `${environment.projects?.['polar']}/search-awb` || '';
    public arrivedDay = '';

    constructor(
        private matDialog: MatDialogRef<MessageModalComponent>,
        private dhlConfigurationService: DHLConfigurationService
    ) {
        this.arrivedDay = this.dhlConfigurationService.getLaunchNewPortalDate().format('MMMM D, YYYY');
    }

    closeDialog(): void {
        this.matDialog.close();
    }
}
